<template>
	<div>
		<input
			v-show="false"
			ref="fileRef"
			type="file"
			accept="image/*"
			data-testid="upload-file"
			@change="uploadFile"
		/>
		<PButton class="width-full" type="text" @click="openFileExplorer">
			{{ buttonText }}
		</PButton>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue'

	interface Props {
		buttonText?: string
	}

	defineProps<Props>()

	const fileRef = ref<HTMLFormElement>()
	const emit = defineEmits(['change'])

	const openFileExplorer = (): void => {
		const input = fileRef.value!
		input.click()
	}

	const uploadFile = (): void => {
		const fileInput = fileRef.value
		const file = fileInput!.files[0]
		emit('change', file)
	}
</script>
